// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"831":"525dbe33","875":"415df158"}[chunkId] + ".chunk.css";
};